/* eslint-disable import/prefer-default-export */
const baseLinkTrackVars = [
  'eVar1',
  'eVar6',
  'eVar10',
  'prop20',
  'eVar23',
  'prop23',
  'prop48',
  'eVar49',
  'eVar61',
  'eVar62',
  'eVar80',
];

/**
 * Converts a network ID into a content ID for analytics.
 * For example: 1:41:39515 becomes 104139515.
 *
 * @param {String} networkId // The network ID from the CMS, e.g. 1:41:39515
 * @returns {String}
 */
const getContentId = (networkId) => {
  const parts = networkId.split(':');
  const siteId = parts.shift();
  return `${siteId}0${parts.join('')}`;
};

/**
 * Convert the post type into a content type.
 *
 * @param {String} type The post type of the card/article.
 * @returns {String}
 */
const getContentType = (type) => {
  if ('video' === type) {
    return 'video hub';
  } else if ('article-lead-video' === type) {
    return 'article lead video embed';
  }
  return 'article';
};

/**
 * Change or reset props in the s global.
 *
 * @param {Object} props
 * @param {Boolean} reset
 */
export const setProps = (props, copy = {}, reset = false) => {
  const keys = Object.keys(props);

  keys.forEach((key) => {
    s[key] = reset ? copy[key] : props[key];
  });
};

/**
 * Wrapper to set props, fire Adobe tl() and then reset props.
 *
 * @param {Object} props The props to set.
 * @param {String} linkType The type of link.
 * @param {String} linkName The name of the link.
 */
export const trackLink = (props, linkType, linkName) => {
  if ('undefined' === typeof s) {
    return;
  }

  // Copy the initial props.
  const copy = { ...s };

  // Update props.
  setProps(props);

  // Make the tracking call.
  s.tl(this, linkType, linkName, null);

  // Set the props back.
  setProps(props, copy, true);
};

/**
 * Track when a user clicks a share button on a card/article.
 *
 * @param {String} id The network id of the card/article.
 * @param {String} title The title of the card/article.
 * @param {String} link The URL of the card/article.
 * @param {String} type The type of card/article, e.g. "article" or "video"
 * @param {String} section The section of the card/article, e.g. "entertainment"
 * @param {String} tag The primary tag of the card/article.
 * @param {Number} position The position where the card appears next to the other cards.
 */
export const trackShareButton = (
  id,
  title,
  link,
  type,
  section,
  tag,
  position
) => {
  const prop21 = getContentId(id);

  // Set the values to track when .tl() is called.
  const linkTrackVars = [
    'eVar21',
    'eVar22',
    'eVar90',
    ...baseLinkTrackVars,
  ].join(',');

  // Calculate the eVar80 value.
  const eVar80 = 'video' === type ? 'video hub' : 'article - general';

  // Calculate the prop23/eVar23 value.
  const prop23 = getContentType(type);

  // Set the props to pass to trackLink.
  const props = {
    eVar1: section,
    eVar6: link,
    prop21,
    eVar22: title,
    prop23,
    eVar23: prop23,
    eVar49: title,
    eVar61: title,
    eVar62: position,
    eVar80,
    eVar90: tag,
    linkTrackVars,
  };

  trackLink(props, 'o', 'share');
};

/**
 * Track when a user views a card/article.
 *
 * @param {String} title The title of the card/article.
 * @param {String} type The type of card/article.
 * @param {Number} index The index position of the card/article.
 */
export const trackCardView = (title, type, index) => {
  // Bail if global not available.
  if ('undefined' === typeof s) {
    return;
  }

  const { fullDomain } = nbc;
  const { eVar1, eVar80 } = s;
  const props = {
    eVar1,
    eVar6: `https://${fullDomain}`,
    prop23: getContentType(type),
    eVar23: type,
    eVar49: title,
    eVar61: title,
    eVar62: index,
    eVar80,
    linkTrackVars: baseLinkTrackVars.join(','),
  };

  trackLink(props, 'o', 'scrolling');
};
